<template>
  <div>
    <div class="search-header d-flex justify-content-between align-items-center mb-3">
      <b-nav pills>
        <b-nav-item :active="filter.status === null" @click="filter.status = null">すべて({{blogList.data.length}})</b-nav-item>
        <b-nav-item :active="filter.status === 'published'" @click="filter.status = 'published'">公開中({{publishedCount.length}})</b-nav-item>
        <b-nav-item :active="filter.status === 'draft'" @click="filter.status = 'draft'">下書き({{draftCount.length}})</b-nav-item>
      </b-nav>
         <div class="search-bar">
           <b-nav-form>
            <b-form-input placeholder="サイト内を検索" class="py-2 mr-1" type="search" v-model="filter.name"></b-form-input>
            <b-button class="search-btn px-4 ml-n2" variant="secondary" type="button">
                <b-icon icon="search" scale="1"></b-icon>
            </b-button>
          </b-nav-form>
         </div>
       </div>
       <div class="responsive-table">
         <b-table id="my-table" head-variant="p-3 mb-2 bg-light text-dark" bordered responsive
            :items="filteredblog"
            :per-page="perPage"
            :current-page="currentPage"
            :fields="fields"
            select-mode="single"
            selectable
            @row-selected="onRowSelected"
            hover
          >
            <template #head(blog_categories)="" class="d-flex">
                <label class="p-2 m-0 mr-1 bg-dark text-white">公開OK</label>
                <label class="p-2 m-0 bg-secondary text-white">編集中</label>
            </template>
            <template #cell(blog_categories)="row">
              <div v-show="row.item.page_status != 'draft'">
                <span class="d-flex">
                 <router-link class="text-white" :to="'/administrator/edit-blog/' + row.item.id + '/name_ja'"><b-button class="mx-1" :variant="languageState(row.value.name_ja)" :class="languageState(row.value.name_ja)">日</b-button></router-link>
                 <router-link class="text-white" :to="'/administrator/edit-blog/' + row.item.id + '/name_en'"><b-button class="mx-1" :variant="languageState(row.value.name_en)" :class="languageState(row.value.name_en)">英</b-button></router-link>
                 <router-link class="text-white" :to="'/administrator/edit-blog/' + row.item.id + '/name_zh-cn'"><b-button class="mx-1" :variant="languageState(row.value['name_zh-cn'])" :class="languageState(row.value['name_zh-cn'])">簡</b-button></router-link>
                 <router-link class="text-white" :to="'/administrator/edit-blog/' + row.item.id + '/name_zh-tw'"><b-button class="mx-1" :variant="languageState(row.value['name_zh-tw'])" :class="languageState(row.value['name_zh-tw'])">繁</b-button></router-link>
                </span>
              </div>
            </template>
            <template #cell(administrative_title)="row">
                <router-link class="text-dark" :to="'/administrator/edit-blog/' + row.item.id"> {{ row.value }}</router-link>
            </template>
          </b-table>
       </div>
        <div>
            <div class="m-4">
            <b-pagination align="center" size="lg" class="position-relative"
                v-model="currentPage"
                :total-rows="filteredblog.length"
                :per-page="perPage"
                :limit="4"
                :show-step-links="true"
                aria-controls
                first-number
                last-number
                v-show="pages"
            >
            <template #prev-text><span><b-icon icon="chevron-left" scale="1.5"></b-icon></span></template>
            <template #next-text><span><b-icon icon="chevron-right" scale="1.5"></b-icon></span></template>
            </b-pagination>
            </div>
        </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      fields: [
        { key: 'administrative_title', label: '記事タイトル', thStyle: { background: '#F8F9FA' } },
        {
          key: 'category',
          label: 'カテゴリ',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return this.$i18n.t(value)
          }
        },
        {
          key: 'status',
          label: 'ステータス',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return this.$i18n.t(value)
          }
        },
        {
          key: 'blog_categories',
          label: 'status',
          thStyle: { background: '#F8F9FA' }
        },
        {
          key: 'created_at',
          label: '最終更新日',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return value.substring(0, 10).replace(/-/g, '/')
          }
        }
      ],
      rows: 8,
      perPage: 30,
      allPage: null,
      currentPage: 1,
      paginate: false,
      filter: {
        name: null,
        status: null
      }
    }
  },
  computed: {
    ...mapState('adminBlog', ['blogList']),
    filteredblog: function () {
      return this.blogList.data
        .filter(this.searchByName)
        .filter(this.filterByPageStatus)
    },
    draftCount: function () {
      return this.blogList.data.filter((blog) => {
        return (blog.status === 'draft')
      })
    },
    publishedCount: function () {
      return this.blogList.data.filter((blog) => {
        return (blog.status === 'published')
      })
    },
    pages: function () {
      if (this.filteredblog.length <= 30) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    ...mapActions('adminBlog', ['getBlogList']),
    buttonState: function () {
      if (this.selected.length === 0) {
        return true
      } else {
        return false
      }
    },
    languageState: function (language) {
      switch (language) {
        case 'published':
          return 'dark'
        case 'draft':
          return 'secondary'
        default:
          return 'invisible'
      }
    },
    searchByName: function (blog) {
      if (this.filter.name === null || this.filter.name === '') {
        return true
      }
      return (blog.administrative_title.toLowerCase().indexOf(this.filter.name.toLowerCase()) >= 0)
    },
    filterByPageStatus: function (blog) {
      if (this.filter.status === null) {
        return true
      }
      return (blog.status === this.filter.status)
    },
    onRowSelected (items) {
      this.$router.push({ name: 'Blog Editing', params: { id: items[0].id } })
    }
  }
}
</script>
